import * as React from 'react';
import { useLocalStorage } from '@lib/hooks';
import { useGroupByIdsV2 } from 'ui-model';
import { useSender } from './useSender';

export const FILTERS_MESSAGE_LOCALSTORAGE = 'lh:filtersMessages';

export const useGetFilterMessagesContext = () => {
  const [persistedFiltersMessages] = useLocalStorage(FILTERS_MESSAGE_LOCALSTORAGE, null, true);
  const initialFilters = persistedFiltersMessages || {
    facilities: [],
    groups: [],
    me: false,
  };
  const [filters, setFilters] = React.useState<{ facilities: string[]; groups: string[]; me: boolean }>(initialFilters);

  const { data: groups = [] } = useGroupByIdsV2({ ids: filters.groups }, { enabled: filters.groups?.length > 0 });

  const facilitiesFromGroups = React.useMemo(() => groups?.map((item) => item.facilities).flat(), [groups]);
  const selectedFacilitiesAndFacilitiesFromGroups = React.useMemo(
    () => [...new Set([...filters.facilities, ...facilitiesFromGroups])],
    [facilitiesFromGroups, filters.facilities],
  );

  const { sender, setSender, isLoadingSender } = useSender(selectedFacilitiesAndFacilitiesFromGroups);

  return {
    filters,
    setFilters,
    sender,
    setSender,
    selectedFacilitiesAndFacilitiesFromGroups,
    isLoadingSender,
  };
};
